import React from 'react';

const CustomBeacon: React.FC = () => (
  <div
    style={{
      width: 18,
      height: 18,
      borderRadius: '50%',
      backgroundColor: '#ff4081',
      boxShadow: '0 0 0 5px rgba(255,64,129,0.4)',
      animation: 'pulse 2s infinite',
    }}
  />
);

export default CustomBeacon;
